import './TopBarBell.scss'

export const TopBarBell2 = ({value = 0}) => {
    return (
        <div className={'main'}>
            <div className={'notification'}>
                <svg viewBox="0 0 15 17">
                    <path
                        className={value > 0 ? 'notification--bell' : ''}
                        d="M14 12v1H0v-1l0.73-0.58c0.77-0.77 0.81-3.55 1.19-4.42 0.77-3.77 4.08-5 4.08-5 0-0.55 0.45-1 1-1s1 0.45 1 1c0 0 3.39 1.23 4.16 5 0.38 1.88 0.42 3.66 1.19 4.42l0.66 0.58z"></path>
                    <path
                        className={value > 0 ? 'notification--bellClapper' : ''}
                        d="M7 15.7c1.11 0 2-0.89 2-2H5c0 1.11 0.89 2 2 2z"></path>
                </svg>
            </div>
        </div>
    )
}

export const TopBarBell = ({value = 0}) => {
    return (
        <div className="main">
            <div className="notification relative">
                <svg
                    viewBox="0 0 28 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    {/* phần bell */}

                    <path
                        className={value > 0 ? 'notification--bell' : ''}
                        d="M10.89 4.33228C7.27429 4.86874 4.50013 7.98574 4.50013 11.7507V14.8647L3.80789 16.7107C3.25629 18.1816 4.34367 19.7507 5.91463 19.7507H18.0856C19.6566 19.7507 20.744 18.1816 20.1924 16.7107L19.5001 14.8647V14.3718C18.6254 14.775 17.6515 15 16.6251 15C12.8282 15 9.75012 11.9219 9.75012 8.12495C9.75012 6.72317 10.1697 5.41937 10.89 4.33228Z"
                        fill="#343C54"
                    />
                    <path
                        opacity={0.3}
                        d="M14.8736 20.7509H9.12622C9.55878 21.918 10.6824 22.7495 11.9999 22.7495C13.3175 22.7495 14.4411 21.918 14.8736 20.7509Z"
                        fill="#343C54"
                    />

                    <circle cx="17" cy="8" r="7.5" fill="red" />
                    <text
                        x="17"
                        y="10"
                        textAnchor="middle"
                        fontSize="6"
                        fontWeight="bold"
                        fill="white">
                        {value}
                    </text>
                </svg>
            </div>
        </div>
    )
}
